module.exports = __webpack_public_path__ + "img/wenliganzhiRight.960fc6c3.gif";